export const tensesQuestions = [
  {
    id: 1,
    koreanQuestion: "내일 이맘때, CEO는 _____ 연설을 연례 회의에서",
    question:
      "At this time tomorrow, the CEO _____ a speech at the annual conference.",
    choices: {
      A: "is delivering",
      B: "will be delivering",
      C: "delivers",
      D: "has delivered",
    },
    correctAnswer: "B",
    explanation:
      "내일 이맘때(미래) A: (현재) 진행 중이다 B: (미래에) 진행중일것이다 C: (현재) 진행한다 D.(현재) 진행했다.",
    translation: "내일 이맘때, CEO는 연례 회의에서 연설 중일 것이다.",
    type: "future continuous",
  },
  {
    id: 2,
    koreanQuestion:
      "이 회사는 전통적으로 _____ 국내 시장에서, 하지만 최근에 해외로 시작했다 제품 수출을",
    question:
      "This company traditionally ______ in domestic markets, but it has recently started exporting products overseas.",
    choices: {
      A: "operates",
      B: "operated",
      C: "is operating",
      D: "will operate",
    },
    correctAnswer: "B",
    explanation:
      "전통적으로(과거에) A:(현재) 운영한다 B:(과거에) 운영했다 C:(현재) 운영 중이다 D:(미래에) 운영할 것이다. ",
    translation:
      "이 회사는 전통적으로 국내 시장에서 운영되었지만, 최근에 해외로 제품 수출을 시작했다.",
    type: "past simple",
  },
  {
    id: 3,
    koreanQuestion:
      "오후 5시 다음주 월요일에,  공사팀은 _____  새로운 보안 카메라를 사무실에",
    question:
      "At 5 PM next Monday, the construction team _____ new security cameras in the office.",
    choices: {
      A: "is installing",
      B: "installs",
      C: "has installed",
      D: "will be installing",
    },
    correctAnswer: "D",
    explanation:
      "미래 오후 5시에 A:(현재) 설치 중이다 B:(현재) 설치한다 C:(현재) 설치했다 D:(미래에) 설치 중일 것이다",
    translation:
      "다음 주 월요일 오후 5시에, 공사팀은 사무실에 새로운 보안 카메라를 설치 중일 것이다.",
    type: "future continuous",
  },
  {
    id: 4,
    koreanQuestion:
      "오전 8시 다음주 금요일에, 매니저는 _____ 분기별 재무 보고서를",
    question:
      "At 8 AM next Friday, the manager _____ the quarterly financial report.",
    choices: {
      A: "is reviewing",
      B: "reviews",
      C: "has reviewed",
      D: "will be reviewing",
    },
    correctAnswer: "D",
    explanation:
      "미래 오전 8시에 A:(현재) 리뷰중이다 B:(현재) 리뷰한다 C:(현재) 리뷰했다 D:(미래에) 리뷰 중일 것이다.",
    translation:
      "다음 주 금요일 오전 8시에 매니저는 분기별 재무 보고서를 검토 중일 것이다.",
    type: "future continuous",
  },
  {
    id: 5,
    koreanQuestion:
      "당신이 호텔에 도착할 때, 직원들은 _____ 당신을 위해 입구에서 ",
    question:
      "When you arrive at the hotel, the staff _____ for you at the entrance.",
    choices: {
      A: "is waiting",
      B: "will be waiting",
      C: "waits",
      D: "has waited",
    },
    correctAnswer: "B",
    explanation:
      "미래에 도착할 때, A:(현재) 기다리는 중이다 B:(미래에) 기다리는 중일 것이다 C:(현재) 기다린다 D:(현재) 기다렸다.",
    translation:
      "당신이 호텔에 도착할 때, 직원들은 입구에서 당신을 기다리는 중일 것이다.",
    type: "future continuous",
  },
  {
    id: 6,
    koreanQuestion: "회의가 시작될 때, 이사는 _____ 새로운 마케팅 전략을",
    question:
      "When the meeting starts, the director _____ the new marketing strategy.",
    choices: {
      A: "will be presenting",
      B: "is presenting",
      C: "presents",
      D: "has presented",
    },
    correctAnswer: "A",
    explanation:
      "미래에 미팅이 시작할 때, A:(미래에) 발표중일 것이다 B:(현재) 발표중이다 C:(현재) 발표한다 D:(현재)발표했다.",
    translation:
      "회의가 시작될 때, 이사는 새로운 마케팅 전략을 발표 중일 것이다.",
    type: "future continuous",
  },
  {
    id: 7,
    koreanQuestion: "내년까지, 회사는 _____ 사업을 5개국에서 1년 동안 ",
    question:
      "By next year, the company _____ its operations in five more countries for a year.",
    choices: {
      A: "is expanding",
      B: "expands",
      C: "will have been expanding",
      D: "has expanded",
    },
    correctAnswer: "C",
    explanation:
      "미래에 내년까지, A:(현재) 확장 중이다 B:(현재) 확장한다 C:(미래에) 확장 중이었을것이다. D:(현재) 확장 했다.",
    translation:
      "내년까지, 회사는 5개국에서 1년 동안 사업을 확장 중이었을 것이다.",
    type: "future perfect continuous",
  },
  {
    id: 8,
    koreanQuestion: "네가 도착할 때까지, 셰프는 _____ 특별 요리를 2시간 넘게",
    question:
      "By the time you arrive, the chef _____ the special dish for over two hours.",
    choices: {
      A: "is preparing",
      B: "prepares",
      C: "will have been preparing",
      D: "has prepared",
    },
    correctAnswer: "C",
    explanation:
      "미래에 도착하면, A:(현재)준비 중이다 B:(현재) 준비한다  C: (미래에) 준비중이었을 것이다. D:(현재) 준비했다.",
    translation:
      "네가 도착할 때까지, 셰프는 2시간 넘게 특별 요리를 준비 중이었을 것이다.",
    type: "future perfect continuous",
  },
  {
    id: 9,
    koreanQuestion:
      "내일까지, 마케팅 팀은 _____  최종 보고서를  분기 검토를 위한",
    question:
      "By tomorrow, the marketing team ______ the final report for the quarterly review.",
    choices: {
      A: "was completing",
      B: "will have completed",
      C: "completed",
      D: "completes",
    },
    correctAnswer: "B",
    explanation:
      "미래 내일까지, A:(과거에) 완료하는 중이었다 B:(미래에) 완료했을 것이다 C:(과거에) 완료했다 D:(현재) 완료한다.",
    translation:
      "내일까지, 마케팅 팀은 분기 검토를 위한 최종 보고서를 완료했을 것이다.",
    type: "future perfect",
  },
  {
    id: 10,
    koreanQuestion:
      "다음 주까지, 회사는 _____  새로운 친환경 제품 라인을 주요 소매점에서",
    question:
      "By next week, the company ______ its new line of eco-friendly products in major retail stores.",
    choices: {
      A: "launches",
      B: "launched",
      C: "will have launched",
      D: "has launched",
    },
    correctAnswer: "C",
    explanation:
      "미래 다음주까지, A:(현재) 출시한다 B:(과거에) 출시했다 C:(미래에) 출시 했을 것이다 D:(현재) 출시 했다.",
    translation:
      "다음 주까지, 회사는 주요 소매점에서 새로운 친환경 제품 라인을 출시했을 것이다.",
    type: "future perfect",
  },
  {
    id: 11,
    koreanQuestion:
      "매니저가 도착할 때까지, 직원들은 _____  회의실 정리를 회의를 위한",
    question:
      "By the time the manager arrives, the employees ______ organizing the conference room for the meeting.",
    choices: {
      A: "finish",
      B: "finished",
      C: "will have finished",
      D: "have finished",
    },
    correctAnswer: "C",
    explanation:
      "미래에 매니저가 도착할 때, A:(현재) 끝난다 B:(과거에) 끝내는 중이다 C:(미래에) 끝냈을 것이다 D:(현재) 끝냈다",
    translation:
      "매니저가 도착할 때까지, 직원들은 회의를 위한 회의실 정리를 끝냈을 것이다.",
    type: "future perfect",
  },
  {
    id: 12,
    koreanQuestion:
      "네가 일어날 때까지, 유지보수팀은 _____ 사무실의 에어컨 시스템을",
    question:
      "By the time you wake up, the maintenance team ______ the air conditioning system in the office.",
    choices: {
      A: "repairs",
      B: "repaired",
      C: "will have repaired",
      D: "has repaired",
    },
    correctAnswer: "C",
    explanation:
      "미래에 너가 일어날 떄까지, A:(현재) 수리한다 B:(과거에) 수리했다 C:(미래에) 수리했을 것이다 D:(현재) 수리했다",
    translation:
      "네가 일어날 때까지, 유지보수팀은 사무실의 에어컨 시스템을 수리했을 것이다.",
    type: "future perfect",
  },
  {
    id: 13,
    koreanQuestion:
      "콘서트가 시작하기 전에, 행사 스태프는 _____ 모든 좌석을 그리고 점검을 음향 시스템 ",
    question:
      "Before the concert starts, the event staff ______ all the seating and checked the sound system.",
    choices: {
      A: "will have arranged",
      B: "arranged",
      C: "arranges",
      D: "has arranged",
    },
    correctAnswer: "A",
    explanation:
      "미래에 콘서트가 시작하기 전에, A:(미래에) 배치했을 것이다. B:(과거에) 배치했다 C:(현재) 배치한다 D:(현재) 배치했다.",
    translation:
      "콘서트가 시작되기 전에, 행사 스태프는 모든 좌석을 배치하고 음향 시스템을 점검했을 것이다.",
    type: "future perfect",
  },
  {
    id: 14,
    koreanQuestion:
      "마감 시한 전까지, 디자인팀은 _____  업데이트된 브로셔를 인쇄 회사에",
    question:
      "Before the deadline, the design team ______ the updated brochure to the printing company.",
    choices: {
      A: "submits",
      B: "is submitting",
      C: "will have submitted",
      D: "has submitted",
    },
    correctAnswer: "C",
    explanation:
      "미래에 마감 전까지, A:(현재) 제출한다 B:(현재) 제출 중이다 C:(미래에) 제출했을 것이다 D:(현재) 제출했다. ",
    translation:
      "마감 시한 전까지, 디자인팀은 인쇄 회사에 업데이트된 브로셔를 제출했을 것이다.",
    type: "future perfect",
  },
  {
    id: 15,
    koreanQuestion:
      "내일, CEO는 _____  회사의 새로운 전략 계획을 기자 회견동안",
    question:
      "Tomorrow, the CEO _____ the company's new strategic plan during the press conference.",
    choices: {
      A: "will announce",
      B: "announces",
      C: "has announced",
      D: "announced",
    },
    correctAnswer: "A",
    explanation:
      "미래 내일, A:(미래에) 발표할 것이다 B:(현재) 발표한다 C:(현재) 발표했다. D:(과거에) 발표했다.",
    translation:
      "내일, CEO는 기자 회견에서 회사의 새로운 전략 계획을 발표할 것이다.",
    type: "future simple",
  },
  {
    id: 16,
    koreanQuestion:
      "다음 주에, 마케팅 팀은 _____ 새로운 광고 캠페인을 제품을 위한 ",
    question:
      "Next week, the marketing team _____ a new advertising campaign for the product.",
    choices: {
      A: "launches",
      B: "has launched",
      C: "will launch",
      D: "launched",
    },
    correctAnswer: "C",
    explanation:
      "미래 다음주에, A:(현재) 시작한다 B:(현재) 시작했다 C:(미래에) 시작할 것이다. D:(과거에) 시작했다.",
    translation:
      "다음 주에, 마케팅 팀은 제품을 위한 새로운 광고 캠페인을 시작할 것이다.",
    type: "future simple",
  },
  {
    id: 17,
    koreanQuestion: "3시간 후에, 기술자는 _____ 유지보수 작업을 서버에 대한 ",
    question:
      "In three hours, the technician _____ the maintenance work on the server.",
    choices: {
      A: "completes",
      B: "has completed",
      C: "will complete",
      D: "completed",
    },
    correctAnswer: "C",
    explanation:
      "미래 3시간 후에, A:(현재) 완료한다 B:(현재) 완료했다 C:(미래에) 완료할 것이다. D:(과거에) 완료했다.",
    translation:
      "3시간 후에, 기술자는 서버에 대한 유지보수 작업을 완료할 것이다.",
    type: "future simple",
  },
  {
    id: 18,
    koreanQuestion: "곧, 회사는 _____ 서비스를 국제 시장으로 ",
    question: "Soon, the company _____ its services to international markets.",
    choices: {
      A: "expands",
      B: "will expand",
      C: "has expanded",
      D: "expanded",
    },
    correctAnswer: "B",
    explanation:
      "미래에 곧, A:(현재) 확장한다 B:(미래에) 확장할 것이다. C:(현재) 확장했다 D:(과거에) 확장했다.",
    translation: "곧, 회사는 국제 시장으로 서비스를 확장할 것이다.",
    type: "future simple",
  },
  {
    id: 19,
    koreanQuestion: "언젠가, 인공지능은 _____ 많은 수동적인 작업들을 직장에서",
    question:
      "Someday, artificial intelligence _____ many manual tasks in the workplace.",
    choices: {
      A: "replaces",
      B: "has replaced",
      C: "will replace",
      D: "replaced",
    },
    correctAnswer: "C",
    explanation:
      "미래 언젠가, A:(현재) 대체한다 B:(현재) 대체했다 C:(미래에) 대체할 것이다. D:(과거에) 대체했다.",
    translation:
      "언젠가, 인공지능은 많은 수동적인 작업들을 직장에서 대체할 것이다.",
    type: "future simple",
  },
  {
    id: 20,
    koreanQuestion:
      "오늘 저녁, 영업팀은 _____ 회의를 / 논의하기 위해 / 분기별 실적을 ",
    question:
      "This evening, the sales team _____ a meeting to discuss the quarterly performance.",
    choices: {
      A: "holds",
      B: "has held",
      C: "will hold",
      D: "held",
    },
    correctAnswer: "C",
    explanation:
      "미래 오늘 저녁에, A:(현재) 개최한다 B:(현재) 개최했다 C:(미래에) 개최할 것이다. D:(과거에) 개최했다.",
    translation:
      "오늘 저녁, 영업팀은 분기별 실적을 논의하기 위한 회의를 개최할 것이다.",
    type: "future simple",
  },
  {
    id: 21,
    koreanQuestion: "내년까지, 회사는 _____ 5개의 새로운 지점들을 전국에 걸쳐",
    question:
      "By next year, the company _____ five new branches across the country.",
    choices: {
      A: "opens",
      B: "has opened",
      C: "will open",
      D: "opened",
    },
    correctAnswer: "C",
    explanation:
      "미래에 내년까지, A:(현재) 연다 B:(현재) 열었다 C:(미래에) 열 것이다. D:(과거에) 열었다.",
    translation:
      "내년까지, 회사는 5개의 새로운 지점들을 전국에 걸쳐 열 것이다.",
    type: "future simple",
  },
  {
    id: 22,
    koreanQuestion: "그녀가 일을 마친 후에, 그녀는 _____ 사무실을",
    question: "After she had finished her work, she _____ the office.",
    choices: {
      A: "leaves",
      B: "has left",
      C: "will leave",
      D: "left",
    },
    correctAnswer: "D",
    explanation:
      "과거에 그녀가 마친 후에, A:(현재) 떠난다 B:(현재) 떠났다 C:(미래에) 떠날 것이다. D:(과거에) 떠났다.",
    translation: "그녀가 일을 마친 후에, 그녀는 사무실을 떠났다.",
    type: "past simple",
  },
  {
    id: 23,
    koreanQuestion: "화물이 도착하자마자, 창고 직원들은 _____ 검사 과정을",
    question:
      "As soon as the shipment arrives, the warehouse staff _____ the inspection process.",
    choices: {
      A: "starts",
      B: "has started",
      C: "will start",
      D: "started",
    },
    correctAnswer: "C",
    explanation:
      "미래에 화물이 도착 하자마자, A:(현재) 시작한다 B:(현재) 시작했다 C:(미래에) 시작할 것이다. D:(과거에) 시작했다.",
    translation:
      "화물이 도착하자마자, 창고 직원들은 검사 과정을 시작할 것이다.",
    type: "future simple",
  },

  {
    id: 27,
    koreanQuestion: "지금, 매니저는 _____ 예산 제안서를 재무팀과",
    question:
      "Now, the manager _____ the budget proposal with the finance team.",
    choices: {
      A: "discussed",
      B: "will discuss",
      C: "had been discussing",
      D: "is discussing",
    },
    correctAnswer: "D",
    explanation:
      "현재 지금, A:(과거에) 논의했다 B:(미래에) 논의할 것이다 C:(과거에) 논의 중이었다. D:(현재) 논의 중이다.",
    translation: "지금, 매니저는 재무팀과 예산 제안서를 논의 중이다.",
    type: "present continuous",
  },
  {
    id: 28,
    koreanQuestion: "지금, 회사는 _____ 새로운 고객 서비스 정책을",
    question: "Now, the company _____ a new customer service policy.",
    choices: {
      A: "implemented",
      B: "will implement",
      C: "had implemented",
      D: "is implementing",
    },
    correctAnswer: "D",
    explanation:
      "현재 지금, A:(과거) 시행했다 B:(미래에) 시행할 것이다 C:(과거에) 시행했다. D:(현재) 시행 중이다.",
    translation: "지금, 회사는 새로운 고객 서비스 정책을 시행 중이다.",
    type: "present continuous",
  },
  {
    id: 29,
    koreanQuestion: "현재, 그녀는 _____ 최신 판매 보고서를",
    question: "At the moment, she _____ the latest sales report.",
    choices: {
      A: "reviewed",
      B: "will review",
      C: "had reviewed",
      D: "is reviewing",
    },
    correctAnswer: "D",
    explanation:
      "현재 지금 이순간, A:(과거에) 검토했다 B:(미래에) 검토할 것이다 C:(과거에) 검토했다. D:(현재) 검토 중이다.",
    translation: "현재, 그녀는 최신 판매 보고서를 검토 중이다.",
    type: "present continuous",
  },
  {
    id: 30,
    koreanQuestion: "현재, IT 부서는 _____ 시스템 오류를",
    question: "At the moment, the IT department _____ the system error.",
    choices: {
      A: "is troubleshooting",
      B: "will troubleshoot",
      C: "had troubleshooted",
      D: "troubleshooted",
    },
    correctAnswer: "A",
    explanation:
      "현재 지금 이순간, A:(현재) 해결 중이다. B:(미래에) 해결할 것이다 C:(과거에) 해결했다. D:(과거에) 해결했다.",
    translation: "현재, IT 부서는 시스템 오류를 해결 중이다.",
    type: "present continuous",
  },
  {
    id: 31,
    koreanQuestion: "현재, 팀은 _____ 주요 소프트웨어 업데이트를 위해",
    question: "Currently, the team _____ on a major software update.",
    choices: {
      A: "worked",
      B: "will work",
      C: "had worked",
      D: "is working",
    },
    correctAnswer: "D",
    explanation:
      "현재, A:(과거에) 작업했다 B:(미래에) 작업할 것이다 C:(과거에) 작업했다. D:(현재) 작업하는 중이다.",
    translation: "현재, 팀은 주요 소프트웨어 업데이트를 위해 작업 중이다.",
    type: "present continuous",
  },
  {
    id: 32,
    koreanQuestion: "현재, 회사는 _____ 사업을 국제 시장으로",
    question:
      "Currently, the company _____ its business into international markets.",
    choices: {
      A: "expanded",
      B: "will expand",
      C: "had expanded",
      D: "is expanding",
    },
    correctAnswer: "D",
    explanation:
      "현재,A:(과거에) 확장했다 B:(미래에) 확장할 것이다 C:(과거에) 확장했다. D:(현재) 확장 중이다.",
    translation: "현재, 회사는 사업을 국제 시장으로 확장 중이다.",
    type: "present continuous",
  },
  {
    id: 33,
    koreanQuestion: "요즘, 더 많은 직원들이 _____ 원격으로 ",
    question:
      "These days, more employees _____ remotely due to flexible work policies.",
    choices: {
      A: "work",
      B: "will work",
      C: "are working",
      D: "have worked",
    },
    correctAnswer: "C",
    explanation:
      "현재 요즈음, A:(현재) 근무한다 B:(미래에) 근무할 것이다 C:(현재) 근무 중이다. D:(현재) 근무했다.",
    translation:
      "요즘, 더 많은 직원들이 유연한 근무 정책으로 인해 원격으로 근무 중이다.",
    type: "present continuous",
  },
  {
    id: 34,
    koreanQuestion: "요즘, 회사는 _____ 지속 가능한 비즈니스 관행에",
    question:
      "These days, the company _____ on sustainable business practices.",
    choices: {
      A: "focuses",
      B: "will focus",
      C: "has focused",
      D: "is focusing",
    },
    correctAnswer: "D",
    explanation:
      "A:(현재) 집중한다 B:(미래에) 집중할 것이다 C:(현재) 집중했다. D:(현재) 집중 중이다.",
    translation: "요즘, 회사는 지속 가능한 비즈니스 관행에 집중 중이다.",
    type: "present continuous",
  },
  {
    id: 35,
    koreanQuestion: "곧, 마케팅 팀은 _____ 새로운 프로모션 캠페인을",
    question: "Soon, the marketing team _____ a new promotional campaign.",
    choices: {
      A: "is launching",
      B: "launched",
      C: "has launched",
      D: "was launching",
    },
    correctAnswer: "A",
    explanation:
      "A:(현재) 시작 중이다. B:(과거) 시작했다 C:(현재) 시작했다. D:(과거에) 시작 중이었다.",
    translation: "곧, 마케팅 팀은 새로운 프로모션 캠페인을 시작 중이다.",
    type: "present continuous",
  },
  {
    id: 36,
    koreanQuestion: "곧, 인사부서는 _____ 새로운 직원 교육 프로그램을",
    question: "Soon, the HR department _____ a new employee training program.",
    choices: {
      A: "was introducing",
      B: "introduced",
      C: "has introduced",
      D: "is introducing",
    },
    correctAnswer: "D",
    explanation:
      "A:(과거에) 도입 중이었다 B:(과거에) 도입했다 C:(현재) 도입했다. D:(현재) 도입 중이다.",
    translation: "곧, 인사부서는 새로운 직원 교육 프로그램을 도입 중이다.",
    type: "present continuous",
  },
  {
    id: 37,
    koreanQuestion: "관리자는 항상 _____ 주간 보고서를 팀 회의 전에",
    question:
      "The supervisor always _____ the weekly reports before the team meeting.",
    choices: {
      A: "is checking",
      B: "checks",
      C: "checked",
      D: "has checked",
    },
    correctAnswer: "B",
    explanation:
      "현재 항상, A:(현재) 확인 중이다 B:(현재) 확인한다 C:(과거에) 확인했다. D:(현재) 확인했다.",
    translation: "관리자는 항상 팀 회의 전에 주간 보고서를 확인한다.",
    type: "present simple",
  },
  {
    id: 38,
    koreanQuestion: "마케팅 팀은 보통 _____ 전략 회의를 금요일 아침에",
    question:
      "(현재) 보통, The marketing team usually _____ strategy meetings on Friday mornings.",
    choices: {
      A: "is holding",
      B: "has held",
      C: "held",
      D: "holds",
    },
    correctAnswer: "D",
    explanation:
      "A:(현재) 여는 중이다 B:(현재) 열었다 C:(과거에) 열었다. D:(현재) 연다.",
    translation: "마케팅 팀은 보통 금요일 아침에 전략 회의를 한다.",
    type: "present simple",
  },
  {
    id: 39,
    koreanQuestion: "직원들은 종종 _____  이메일을 회사 정책 업데이트에 관한",
    question: "Employees often _____ emails regarding company policy updates.",
    choices: {
      A: "receive",
      B: "have received",
      C: "received",
      D: "are receiving",
    },
    correctAnswer: "A",
    explanation:
      "(현재) 종종, A:(현재) 받는다 B:(현재) 받았다 C:(과거에) 받았다. D:(현재) 받는 중이다.",
    translation: "직원들은 자주 회사 정책 업데이트에 관한 이메일을 받는다.",
    type: "present simple",
  },
  {
    id: 40,
    koreanQuestion: "영업부는 때때로 _____ 마감 기한을 고객 제안서에 대한",
    question:
      "The sales department sometimes _____ deadlines for client proposals.",
    choices: {
      A: "is extending",
      B: "has extended",
      C: "extended",
      D: "extends",
    },
    correctAnswer: "D",
    explanation:
      "(현재) 때때로, A:(현재) 연장 중이다 B:(현재) 연장했다 C:(과거에) 연장했다. D:(현재) 연장한다.",
    translation: "영업부는 때때로 고객 제안서에 대한 마감 기한을 연장한다.",
    type: "present simple",
  },
  {
    id: 41,
    koreanQuestion: "회사는 가끔 _____ 추가 교육을 신입 직원들을 위한",
    question:
      "The company occasionally _____ additional training for new employees.",
    choices: {
      A: "is providing",
      B: "has provided",
      C: "provides",
      D: "provided",
    },
    correctAnswer: "C",
    explanation:
      "(현재) 가끔, A:(현재) 제공 중이다 B:(현재) 제공했다 C:(현재) 제공한다. D:(과거에) 제공했다.",
    translation: "회사는 가끔 신입 직원들을 위한 추가 교육을 제공한다.",
    type: "present simple",
  },
  {
    id: 42,
    koreanQuestion: "IT 부서는 드물게 _____ 시스템 장애를",
    question: "The IT department rarely _____ system failures.",
    choices: {
      A: "is experiencing",
      B: "has experienced",
      C: "experienced",
      D: "experiences",
    },
    correctAnswer: "D",
    explanation:
      "(현재) 드물게 A:(현재) 경험 중이다 B:(현재) 경험했다 C:(과거에) 경험했다. D:(현재) 경험한다.",
    translation: "IT 부서는 드물게 시스템 장애를 경험한다.",
    type: "present simple",
  },
  {
    id: 43,
    koreanQuestion: "매니저는 좀처럼 _____ 마지막 순간의 일정 변경을",
    question: "The manager seldom _____ last-minute schedule changes.",
    choices: {
      A: "is approving",
      B: "has approved",
      C: "approves",
      D: "approved",
    },
    correctAnswer: "C",
    explanation:
      "(현재) 좀처럼 A:(현재) 승인 중이지 않다 B:(현재) 승인하지 않았다 C:(현재) 승인하지 않는다. D:(과거에) 승인하지 않았다..",
    translation: "매니저는 좀처럼 마지막 순간의 일정 변경을 승인하지 않는다.",
    type: "present simple",
  },
  {
    id: 44,
    koreanQuestion: "CEO는 절대 _____ 중요한 발표를 이사회와 상의 없이",
    question:
      "The CEO never _____ important announcements without consulting the board.",
    choices: {
      A: "is making",
      B: "makes",
      C: "made",
      D: "was making",
    },
    correctAnswer: "B",
    explanation:
      "절대, A:(현재) -하는 중이다 B:(현재) -한다 C:(과거에) -했다. D:(과거에) -하는 중이었다.",
    translation: "CEO는 절대 이사회와 상의 없이 중요한 발표를 하지 않는다.",
    type: "present simple",
  },
  {
    id: 45,
    koreanQuestion: "고객 서비스팀은 _____ 문의사항에 매일",
    question: "The customer service team _____ to inquiries every day.",
    choices: {
      A: "is responding",
      B: "has responded",
      C: "responded",
      D: "responds",
    },
    correctAnswer: "D",
    explanation:
      "A:(현재) 응답 하는 중이다 B:(현재) 응답했다 C:(과거에) 응답했다. D:(현재) 응답한다.",
    translation: "고객 서비스팀은 매일 문의사항에 응답한다.",
    type: "present simple",
  },
  {
    id: 46,
    koreanQuestion: "재무부는 _____ 급여를 월요일에",
    question: "The finance department _____ payroll on Monday.",
    choices: {
      A: "processes",
      B: "has processed",
      C: "processed",
      D: "is processing",
    },
    correctAnswer: "A",
    explanation:
      "A:(현재) 처리한다 B:(현재) 처리했다 C:(과거에) 처리했다. D:(현재) 처리 하는 중이다.",
    translation: "재무부는 월요일에 급여를 처리한다.",
    type: "present simple",
  },
  {
    id: 47,
    koreanQuestion: "처음으로 그녀가  _____  국제 비즈니스 컨퍼런스",
    question:
      "This is the first time she _____ an international business conference.",
    choices: {
      A: "attends",
      B: "attended",
      C: "had attended",
      D: "has attended",
    },
    correctAnswer: "D",
    explanation:
      "A:(현재) 참석 하는 중이다 B:(현재) 참석했다 C:(과거에) 참석했다. D:(현재) 참석한다.",
    translation: "이것은 그녀가 국제 비즈니스 컨퍼런스에 참석한 첫 번째이다.",
    type: "present perfect",
  },

  {
    id: 50,
    koreanQuestion: "그녀는 _____ 고객의 사무실을 두 번 이번 달에",
    question: "She _____ the client's office twice this month.",
    choices: {
      A: "visits",
      B: "visited",
      C: "had visited",
      D: "has visited",
    },
    correctAnswer: "D",
    explanation:
      "A:(현재) 방문한다 B:(과거에) 방문했다 C:(과거에) 방문했다. D:(현재) 방문했다.",
    translation: "그녀는 이번 달에 고객의 사무실을 두 번 방문했다.",
    type: "present perfect",
  },
  {
    id: 51,
    koreanQuestion: "회의가 시작되기 전에 그들은 이미 보고서를 완료___",
    question:
      "Before the meeting started, they _____ already completed the report.",
    choices: {
      A: "have",
      B: "has",
      C: "had",
      D: "did",
    },
    correctAnswer: "C",
    explanation:
      "A:(현재:복수) ~했다 B:(현재:단수) ~했다 C:(과거) ~했다 D:(과거) 했다.",
    translation: "회의가 시작되기 전에 그들은 이미 보고서를 완료했었다.",
    type: "past perfect",
  },
  {
    id: 52,
    koreanQuestion: "회사는 이미 출시 _____ / 새로운 제품을 / 여러 국가에서",
    question:
      "The company _____ already launched its new product in several countries.",
    choices: {
      A: "is",
      B: "have",
      C: "had",
      D: "has",
    },
    correctAnswer: "D",
    explanation:
      "A:(현재) -이다 B:(현재:복수) -했다 C:(과거에) -했다. D:(현재:단수) -했다.",
    translation: "회사는 이미 여러 국가에서 새로운 제품을 출시했다.",
    type: "present perfect",
  },
  {
    id: 53,
    koreanQuestion: "IT 부서는 최근에 업그레이드___ 보안 시스템을",
    question: "The IT department _____ recently upgraded the security system.",
    choices: {
      A: "is",
      B: "have",
      C: "had",
      D: "has",
    },
    correctAnswer: "D",
    explanation:
      "A:(현재) -이다 B:(현재:복수) -했다 C:(과거에) -했다. D:(현재:단수) -했다.",
    translation: "IT 부서는 최근에 보안 시스템을 업그레이드했다.",
    type: "present perfect",
  },
  {
    id: 54,
    koreanQuestion: "회사는 _____ 급격히 최근에 수요 증가로 인해 ",
    question: "The company _____ rapidly lately due to increased demand.",
    choices: {
      A: "grows",
      B: "has grown",
      C: "had grown",
      D: "grew",
    },
    correctAnswer: "B",
    explanation:
      "A:(현재) 성장한다 B:(현재) 성장했다 C:(과거에) 성장했다. D:(과거에) 성장했다.",
    translation: "회사는 최근에 수요 증가로 인해 급속히 성장했다.",
    type: "present perfect",
  },
  {
    id: 55,
    koreanQuestion: "지금까지, 마케팅 캠페인은 _____ 긍정적인 피드백을",
    question: "So far, the marketing campaign _____ positive feedback.",
    choices: {
      A: "generates",
      B: "generated",
      C: "had generated",
      D: "has generated",
    },
    correctAnswer: "D",
    explanation:
      "A:(현재) 생성한다 B:(과거에) 생성했다 C:(과거에) 생성했다. D:(현재) 생성했다.",
    translation: "지금까지, 마케팅 캠페인은 긍정적인 피드백을 생성했다.",
    type: "present perfect",
  },
  {
    id: 56,
    koreanQuestion: "지금까지, 우리는 _____ 80%를 프로젝트 마일스톤의 ",
    question: "Up to now, we _____ 80% of the project milestones.",
    choices: {
      A: "complete",
      B: "completed",
      C: "have completed",
      D: "had completed",
    },
    correctAnswer: "C",
    explanation:
      "A:(현재) 완료한다 B:(과거에) 완료했다 C:(현재) 완료했다. D:(과거에) 완료했다.",
    translation: "지금까지, 우리는 프로젝트 마일스톤의 80%를 완료했다.",
    type: "present perfect",
  },
  {
    id: 57,
    koreanQuestion:
      "지금까지, 어떤 고객도 _____ 새로운 소프트웨어에 대한 문제를",
    question: "Until now, no customer _____ any issues with the new software.",
    choices: {
      A: "reports",
      B: "reported",
      C: "had reported",
      D: "has reported",
    },
    correctAnswer: "D",
    explanation:
      "A:(현재) 보고하지 않는다 B:(과거에) 보고하지 않았다 C:(과거에) 보고하지 않았다. D:(현재) 보고하지 않았다.",
    translation:
      "지금까지, 어떤 고객도 새로운 소프트웨어에 대한 문제를 보고하지 않았다.",
    type: "present perfect",
  },
  {
    id: 58,
    koreanQuestion: "지난 5년 동안, 회사는 _____ 운영을 전 세계적으로 ",
    question:
      "For the past five years, the company _____ its operations globally.",
    choices: {
      A: "has expanded",
      B: "expanded",
      C: "had expanded",
      D: "expands",
    },
    correctAnswer: "A",
    explanation:
      "A:(현재) 확장했다 B:(과거에) 확장했다 C:(과거에) 확장했다. D:(현재) 확장한다.",
    translation: "지난 5년 동안, 회사는 전 세계적으로 운영을 확장했다.",
    type: "present perfect",
  },
  {
    id: 59,
    koreanQuestion: "회사는 _____ 글로벌 입지를 지난 5년 동안 ",
    question: "The company _____ its global presence for the past five years.",
    choices: {
      A: "is expanding",
      B: "has been expanding",
      C: "expands",
      D: "expanded",
    },
    correctAnswer: "B",
    explanation:
      "A:(현재) 확장 중이다. B:(현재) 확장 중이었다 C:(현재) 확장한다. D:(과거에) 확장했다.",
    translation: "회사는 지난 5년 동안 글로벌 입지를 확장 중이었다.",
    type: "present perfect continuous",
  },
  {
    id: 60,
    koreanQuestion: "그녀는 _____  영업부를 2018년부터",
    question: "She _____ the sales department since 2018.",
    choices: {
      A: "manages",
      B: "has been managing",
      C: "managed",
      D: "is managing",
    },
    correctAnswer: "B",
    explanation:
      "A:(현재) 관리한다. B:(현재) 관리 중이었다 C:(과거에) 관리했다. D:(현재) 관리 중이다.",
    translation: "그녀는 2018년부터 영업부를 관리중이었다.",
    type: "present perfect continuous",
  },
  {
    id: 61,
    koreanQuestion: "IT팀은 _____  서버 문제를 하루 종일 ",
    question: "The IT team _____ the server issue all day.",
    choices: {
      A: "is troubleshooting",
      B: "has been troubleshooting",
      C: "troubleshoots",
      D: "troubleshooted",
    },
    correctAnswer: "B",
    explanation:
      "A:(현재) 해결 중이다. B:(현재) 해결 중이었다 C:(현재) 해결한다. D:(과거에) 해결했다.",
    translation: "IT팀은 하루 종일 서버 문제를 해결중이었다.",
    type: "present perfect continuous",
  },
  {
    id: 62,
    koreanQuestion: "현재, 회사는 _____ 디지털 전환 전략에",
    question:
      "For now, the company _____ on digital transformation strategies.",
    choices: {
      A: "has been focusing",
      B: "focuses",
      C: "focused",
      D: "is focusing",
    },
    correctAnswer: "A",
    explanation:
      "A:(현재) 집중 중이었다. B:(현재) 집중한다 C:(과거에) 집중했다. D:(현재) 집중 중이다.",
    translation: "현재, 회사는 디지털 전환 전략에 집중 중이었다.",
    type: "present perfect continuous",
  },
  {
    id: 63,
    koreanQuestion: "요즘, 직원들은 _____ 원격으로 더 자주 ",
    question: "These days, employees _____ remotely more frequently.",
    choices: {
      A: "work",
      B: "worked",
      C: "have been working",
      D: "are working",
    },
    correctAnswer: "C",
    explanation:
      "A:(현재) 근무한다. B:(과거에) 근무했다 C:(현재) 근무 중이었다. D:(현재) 근무 중이다.",
    translation: "요즘, 직원들은 더 자주 원격으로 근무 중이었다.",
    type: "present perfect continuous",
  },
  {
    id: 64,
    koreanQuestion: "지난 3개월 동안, 마케팅 팀은 _____ 새로운 캠페인을",
    question:
      "Over the past three months, the marketing team _____ a new campaign.",
    choices: {
      A: "develops",
      B: "developed",
      C: "has been developing",
      D: "is developing",
    },
    correctAnswer: "C",
    explanation:
      "A:(현재) 개발한다. B:(과거에) 개발했다 C:(현재) 개발 중이었다. D:(현재) 개발 중이다.",
    translation: "지난 3개월 동안, 마케팅 팀은 새로운 캠페인을 개발중이었다.",
    type: "present perfect continuous",
  },
  {
    id: 65,
    koreanQuestion: "그녀가 _____ 사무실에 회의는 이미 시작되어 있었다",
    question: "When she _____ at the office, the meeting had already started.",
    choices: {
      A: "arrived",
      B: "has arrived",
      C: "arrives",
      D: "is arriving",
    },
    correctAnswer: "A",
    explanation:
      "A:(과거에) 도착했다. B:(현재) 도착했다 C:(현재) 도착한다. D:(현재) 도착 중이다.",
    translation: "그녀가 사무실에 도착했을 때 회의는 이미 시작되어 있었다.",
    type: "past simple",
  },
  {
    id: 66,
    koreanQuestion: "2015년에, 회사는 _____ 첫 번째 해외 지점을",
    question: "In 2015, the company _____ its first international branch.",
    choices: {
      A: "launched",
      B: "has launched",
      C: "launches",
      D: "is launching",
    },
    correctAnswer: "A",
    explanation:
      "A:(과거에) 설립했다. B:(현재) 설립했다 C:(현재) 설립한다. D:(현재) 설립 중이다.",
    translation: "2015년에, 회사는 첫 번째 해외 지점을 설립했다.",
    type: "past simple",
  },
  {
    id: 67,
    koreanQuestion: "지난 월요일에, 매니저는 _____ 새로운 정책을 직원들에게",
    question: "Last Monday, the manager _____ the new policy to the employees.",
    choices: {
      A: "has announced",
      B: "announced",
      C: "announces",
      D: "is announcing",
    },
    correctAnswer: "B",
    explanation:
      "A:(현재) 발표했다. B:(과거에) 발표했다 C:(현재) 발표한다. D:(현재) 발표 중이다.",
    translation: "지난 월요일에, 매니저는 직원들에게 새로운 정책을 발표했다.",
    type: "past simple",
  },
  {
    id: 68,
    koreanQuestion: "그 당시, 나는 _____  인턴으로 마케팅 회사에서",
    question: "At that time, I _____ as an intern at a marketing firm.",
    choices: {
      A: "worked",
      B: "have worked",
      C: "work",
      D: "am working",
    },
    correctAnswer: "A",
    explanation:
      "A:(과거에) 일했다. B:(현재) 일했다 C:(현재) 일한다. D:(현재) 일하는 중이다.",
    translation: "그 당시, 나는 마케팅 회사에서 인턴으로 일했다.",
    type: "past simple",
  },
  {
    id: 69,
    koreanQuestion: "그 시절에는, 사람들은 _____  신문에 일간 뉴스를 위해",
    question: "In those days, people _____ on newspapers for daily news.",
    choices: {
      A: "rely",
      B: "have relied",
      C: "relied",
      D: "are relying",
    },
    correctAnswer: "C",
    explanation:
      "A:(현재) 의존한다. B:(현재) 의존했다 C:(과거에) 의존했다. D:(현재) 의존 중이다.",
    translation: "그 시절에는, 사람들은 일간 뉴스를 위해 신문에 의존했다.",
    type: "past simple",
  },
  {
    id: 70,
    koreanQuestion: "어제, IT팀은 _____ 시스템 버그를 마감 시한 전에",
    question:
      "Yesterday, the IT team _____ the system bug before the deadline.",
    choices: {
      A: "fixed",
      B: "has fixed",
      C: "fixes",
      D: "is fixing",
    },
    correctAnswer: "A",
    explanation:
      "A:(과거에) 수정했다. B:(현재) 수정했다 C:(현재) 수정한다. D:(현재) 수정 중이다.",
    translation: "어제, IT팀은 마감 시한 전에 시스템 버그를 수정했다.",
    type: "past simple",
  },
  {
    id: 71,
    koreanQuestion: "2년 전에, 회사는 _____ 새로운 직원 복리후생 프로그램을",
    question:
      "Two years ago, the company _____ a new employee benefits program.",
    choices: {
      A: "is introducing",
      B: "has introduced",
      C: "introduces",
      D: "introduced",
    },
    correctAnswer: "D",
    explanation:
      "A:(현재) 도입 중이다. B:(현재) 도입했다 C:(현재) 도입한다. D:(과거에) 도입했다.",
    translation: "2년 전에, 회사는 새로운 직원 복리후생 프로그램을 도입했다.",
    type: "past simple",
  },
  {
    id: 72,
    koreanQuestion: "지난주, 영업부는 _____ 특별 교육 세션을",
    question:
      "Last week, the sales department _____ a special training session.",
    choices: {
      A: "held",
      B: "has held",
      C: "holds",
      D: "is holding",
    },
    correctAnswer: "A",
    explanation:
      "A:(과거에) 개최했다. B:(현재) 개최했다 C:(현재) 개최한다. D:(현재) 개최 중이다.",
    translation: "지난주, 영업부는 특별 교육 세션을 개최했다.",
    type: "past simple",
  },

  {
    id: 74,
    koreanQuestion:
      "컨퍼런스 동안, CEO는 _____ 영감을 주는 연설을 혁신에 대한 ",
    question:
      "During the conference, the CEO _____ an inspiring speech about innovation.",
    choices: {
      A: "gave",
      B: "has given",
      C: "gives",
      D: "is giving",
    },
    correctAnswer: "A",
    explanation:
      "A:(과거에) -했다. B:(현재) -했다 C:(현재) -한다. D:(현재) - 중이다.",
    translation: "컨퍼런스 동안, CEO는 혁신에 대한 영감을 주는 연설을 했다.",
    type: "past simple",
  },
  {
    id: 75,
    koreanQuestion: "매출이 _____ 지난 3년 동안,  이어지며 사상 최고 이익으로",
    question:
      "Sales ______ in the past three years, leading to record-high profits.",
    choices: {
      A: "increase",
      B: "increased",
      C: "have increased",
      D: "had increased",
    },
    correctAnswer: "C",
    explanation:
      "A:(현재) 증가한다. B:(과거에) 증가했다 C:(현재) 증가했다. D:(과거에) 증가했다.",
    translation: "매출이 지난 3년 동안 증가했고, 사상 최고 이익으로 이어졌다.",
    type: "present perfect",
  },

  {
    id: 77,
    koreanQuestion:
      "회사는 _____  상당한 손실을 지난 2년 동안, 대규모 예산 삭감으로 이어지며",
    question:
      "The company _____ significant losses in the past two years, resulting in major budget cuts.",
    choices: {
      A: "suffered",
      B: "has suffered",
      C: "suffers",
      D: "had suffered",
    },
    correctAnswer: "B",
    explanation:
      "A:(과거에) 겪었다. B:(현재) 겪었다 C:(현재) 겪는다. D:(과거에) 겪었다.",
    translation:
      "회사는 지난 2년 동안 상당한 손실을 겪었고, 대규모 예산 삭감으로 이어졌다.",
    type: "present perfect",
  },
  {
    id: 78,
    koreanQuestion:
      "고객 불만이 _____  상당히 지난 해 동안, 경영진들 사이에 우려를 일으키며",
    question:
      "Customer complaints _____ significantly in the past year, causing concerns among executives.",
    choices: {
      A: "rose",
      B: "were rising",
      C: "have risen",
      D: "had risen",
    },
    correctAnswer: "C",
    explanation:
      "A:(과거에) 증가했다. B:(과거에) 증가하는 중이었다 C:(현재) 증가했다. D:(과거에) 증가했다.",
    translation:
      "고객 불만이 지난 해 동안 상당히 증가했고, 경영진들 사이에 우려를 일으켰다.",
    type: "present perfect",
  },
  {
    id: 79,
    koreanQuestion: "매니저가 도착했을 때까지, 팀은 _____ 프레젠테이션을",
    question:
      "By the time the manager arrived, the team _______ the presentation.",
    choices: {
      A: "have finished",
      B: "had finished",
      C: "finishes",
      D: "is finishing",
    },
    correctAnswer: "B",
    explanation:
      "A:(현재) 끝냈다. B:(과거에) 끝냈다 C:(현재) 끝난다. D:(현재) 끝내는 중이다.",
    translation: "매니저가 도착했을 때까지, 팀은 프레젠테이션을 끝냈다.",
    type: "past perfect",
  },
  {
    id: 80,
    koreanQuestion: "마감 기한이 지나기 전에, 그녀는 _____ 최종 보고서를",
    question: "Before the deadline passed, she _______ the final report.",
    choices: {
      A: "have submitted",
      B: "had submitted",
      C: "submits",
      D: "is submitting",
    },
    correctAnswer: "B",
    explanation:
      "A:(현재) 제출했다. B:(과거에) 제출했다 C:(현재) 제출한다. D:(현재) 제출하는 중이다.",
    translation: "마감 기한이 지나기 전에, 그녀는 최종 보고서를 제출했다.",
    type: "past perfect",
  },
  {
    id: 81,
    koreanQuestion: "고객이 떠난 후, 영업팀은 _____ 협상 결과를",
    question:
      "After the client left, the sales team _______ the negotiation results.",
    choices: {
      A: "have discussed",
      B: "had discussed",
      C: "discusses",
      D: "is discussing",
    },
    correctAnswer: "A",
    explanation:
      "A:(현재) 논의했다. B:(과거에) 논의했다 C:(현재) 논의한다. D:(현재) 논의하는 중이다.",
    translation: "고객이 떠난 후, 영업팀은 협상 결과를 논의했다.",
    type: "past simple",
  },
  {
    id: 82,
    koreanQuestion: "그는 _____ 그때까지 해외로",
    question: "He _______ abroad until then.",
    choices: {
      A: "have never traveled",
      B: "had never traveled",
      C: "never travels",
      D: "is never traveling",
    },
    correctAnswer: "B",
    explanation:
      "A:(현재) 여행하지 않았다. B:(과거에) 여행하지 않았다 C:(현재) 여행하지 않는다. D:(현재) 여행중이 아니다.",
    translation: "그는 그때까지 해외로 여행하지 않았다.",
    type: "past perfect",
  },
  {
    id: 83,
    koreanQuestion: "그 시점에, 회사는 _____ 확장하기로 운영을 국제적으로 ",
    question:
      "At that point, the company _______ to expand its operations internationally.",
    choices: {
      A: "decided",
      B: "had decided",
      C: "decides",
      D: "is deciding",
    },
    correctAnswer: "B",
    explanation:
      "A:(현재) 제출했다. B:(과거에) 제출했다 C:(현재) 제출한다. D:(현재) 제출하는 중이다.",
    translation: "그 시점에, 회사는 국제적으로 운영을 확장하기로 결정했다",
    type: "past perfect",
  },
  {
    id: 84,
    koreanQuestion: "내가 방에 들어갔을 때, 그들은 _____ 새로운 프로젝트를",
    question: "When I walked into the room, they _____ the new project.",
    choices: {
      A: "discussed",
      B: "were discussing",
      C: "discuss",
      D: "have discussed",
    },
    correctAnswer: "B",
    explanation:
      "A:(과거에) 논의했다. B:(과거에) 논의 중이었다 C:(현재) 논의한다. D:(현재) 논의했다.",
    translation:
      "내가 방에 (과거에) 들어갔을 때, 그들은 새로운 프로젝트를 (과거에) 논의 중이었다.",
    type: "past continuous",
  },

  {
    id: 85,
    koreanQuestion: "그녀가 _____ 프레젠테이션을 , 화재 경보가 갑자기 울렸다",
    question:
      "While she _____ her presentation, the fire alarm suddenly went off.",
    choices: {
      A: "gave",
      B: "gives",
      C: "was giving",
      D: "has given",
    },
    correctAnswer: "C",
    explanation:
      "A:(과거에) -했다. B:(현재) -한다. C:(과거에)- 하는 중이었다 D:(현재) -했다.",
    translation:
      "그녀가 프레젠테이션을 (과거에) 하고 있는 동안, 화재 경보가 갑자기 (과거에) 울렸다.",
    type: "past continuous",
  },
  {
    id: 87,
    koreanQuestion: "그 순간, 우리는 _____ 행사의 생중계를",
    question: "At that moment, we _____ the live broadcast of the event.",
    choices: {
      A: "watched",
      B: "were watching",
      C: "watch",
      D: "have watched",
    },
    correctAnswer: "B",
    explanation:
      "A:(과거에) 보았다. B:(과거에) 보고 있는 중이었다 C:(현재) 본다. D:(현재) 보았다.",
    translation: "그 순간, 우리는 행사의 생중계를 보고 있는 중이었다.",
    type: "past continuous",
  },
  {
    id: 88,
    koreanQuestion: "내가 _____ 직장에 가는 동안, 비가 심하게 내리기 시작했다",
    question: "While I _____ to work, it started raining heavily.",
    choices: {
      A: "drove",
      B: "drive",
      C: "was driving",
      D: "have driven",
    },
    correctAnswer: "C",
    explanation:
      "A:(과거에) 갔다. B:(현재) 간다. C:(과거에) 가는 중이었다 D:(현재) 갔다.",
    translation: "내가 직장에 가고 있는 동안, 비가 심하게 내리기 시작했다.",
    type: "past continuous",
  },
  {
    id: 89,
    koreanQuestion: "나는 한때 _____ 뉴욕에서 1년 동안",
    question: "I once _____ in New York for a year.",
    choices: {
      A: "have lived",
      B: "lived",
      C: "live",
      D: "am living",
    },
    correctAnswer: "B",
    explanation:
      "A:(현재) 살았다. B:(과거에) 살았다 C:(현재) 산다. D:(현재) 살고 있는 중이다.",
    translation: "나는 한때 뉴욕에서 1년 동안 (과거에)살았다.",
    type: "past simple",
  },
  {
    id: 90,
    koreanQuestion: "그는 한때 _____ 교사가 되기 전에 요리사로",
    question: "He once _____ as a chef before becoming a teacher.",
    choices: {
      A: "has worked",
      B: "worked",
      C: "works",
      D: "is working",
    },
    correctAnswer: "B",
    explanation:
      "A:(현재) 일했다. B:(과거에) 일했다 C:(현재) 일한다. D:(현재) 일하는 중이다.",
    translation: "그는 한때 교사가 되기 전에 요리사로 일했다.",
    type: "past simple",
  },
];
